import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import InfoButton from './InfoButton';
import { gridName } from '../js/constants';
import { checkGridAvailable } from '../js/utilityRoutines';

export default function GridSelect(props) {
  const { userParams, setUserParams, selectOptions, setDisableGoButton, gridError, setGridError, gridEndDate, setGridEndDate } = props;

  const gridChoices = []
  for (const [value, label] of Object.entries(gridName)) {
    gridChoices.push({value, label});
  }

  const handleGridChange = (event) => {
    let newGrid = event.target.value ? event.target.value : "";
    setUserParams({ ...userParams, grid:newGrid});
    if (newGrid === "") {
        setGridError("Select dataset");
        setDisableGoButton(true);
    } else {
        checkGridAvailable({ ...userParams, grid:newGrid}, setGridError, setDisableGoButton, gridEndDate, setGridEndDate);
    }
  }

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <TextField
            select
            name="grid"
            label="Dataset"
            value={userParams.grid}
            onChange={handleGridChange}
            error={gridError.length > 0}
            helperText={gridError.length > 0 ? gridError : ""}
            InputProps={{endAdornment: <InfoButton adornment="end" infoFor='gridinfo' />}}
            sx={{ mb: 0, "& .MuiSelect-icon": { right: '28px' } }}
            >
            {selectOptions(gridChoices)}
        </TextField>
      </Stack>
    </>
  )
}